<template>
  <div>
    <v-banner icon="credit_card">
      Your Credit/Debit Cards
      <template v-slot:actions>
        <v-btn color="success" outlined :to="{name:'AddNewCard'}">
          <v-icon left>add</v-icon>Add New Card
        </v-btn>
      </template>
    </v-banner>

    <v-card flat color="background" :loading="loadingData">
      <v-expansion-panels focusable flat accordion class="mt-2 mb-4" v-if="paymentSources.length">
        <v-expansion-panel v-for="card in paymentSources" :key="card.id">
          <v-expansion-panel-header class="subtitle-2">
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Type</v-list-item-title>
                  <v-list-item-subtitle>
                    <strong>{{getCardName(card.card.brand)}}</strong>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content>
                  <v-list-item-title>Last 4 Digits</v-list-item-title>
                  <v-list-item-subtitle>**** {{card.card.last4}}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content>
                  <v-list-item-title>Expiry</v-list-item-title>
                  <v-list-item-subtitle>{{card.card.exp_month}} / {{card.card.exp_year}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <template v-slot:actions>
              <v-icon color="info">add</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="body-2 mt-2">
            <v-row>
              <v-col cols="12" md="6">
                <v-card-title class="subtitle-2 font-weight-bold py-0">Name on Card</v-card-title>
                <v-card-text>{{card.billing_details.name}}</v-card-text>
              </v-col>
              <v-col cols="12" md="6">
                <v-card-title class="subtitle-2 font-weight-bold py-0">Billing Details</v-card-title>
                <v-card-text>
                  <span>{{card.billing_details.address.line1}}</span>
                  <br />
                  <span>{{card.billing_details.address.line2}}</span>
                  <br />
                  <span>{{card.billing_details.address.city}}</span>
                  <br />
                  <span>{{card.billing_details.address.postal_code}}</span>
                  <br />
                  <span>{{card.billing_details.phone}}</span>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row align="start">
              <v-col cols="12">
                <v-card-actions>
                  <v-chip color="green" text-color="white" v-if="isDefaultCard(card.id)">
                    Default Card
                    <v-icon right>done</v-icon>
                  </v-chip>
                  <v-btn
                    text
                    outlined
                    color="blue darken-2"
                    @click.stop="setDefaultPaymentMethod(card.id)"
                    v-else
                  >Set Default</v-btn>
                  <v-spacer></v-spacer>

                  <!------Edit Card Details-------->

                  <v-dialog v-model="paymentCardDialog" persistent max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" outlined v-bind="attrs" v-on="on">
                        <v-icon left>mdi-pencil</v-icon>Edit
                      </v-btn>
                    </template>
                    <PaymentCard
                      isEditingCard
                      :paymentMethodId="card.id"
                      :sources="paymentSources"
                      @card-update="getPaymentMethods"
                      @card-closed="paymentCardDialog=false"
                    />
                  </v-dialog>
                  <v-spacer></v-spacer>
                  <!------Remove Card-------->
                  <v-dialog v-model="deleteCardDialog" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="red" outlined v-bind="attrs" v-on="on">Remove</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        Delete Card
                        <v-spacer />
                        <v-btn icon @click.stop="deleteCardDialog=false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>This action cannot be undone . Are you sure you want to remove this card?</v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn text color="black" @click.stop="deleteCardDialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="red" :loading="isProcessing" outlined @click="deletePaymentSource(card.id)">Delete</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-divider></v-divider>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-text v-else>{{noCardText}}</v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PaymentCard from "@/components/payment/PaymentCardForm.vue";
export default {
  name: "ManageSavedCards",
  components: { PaymentCard },
  data: () => {
    return {
      cardManagment: true,
      paymentSources: [],
      defaultSource: null,
      deleteCardDialog: false,
      paymentCardDialog: false,
      loadingData: false,
      noCardText: "",
      isProcessing:false
    };
  },
  computed: {
    ...mapGetters(["retrieveUser"])
  },
  methods: {
    ...mapActions([
      "setSnackbar",
      "getSavedPaymentMethods",
      "removeSourceAction",
      "setDefaultSourceAction"
    ]),
    isDefaultCard(card) {
      if (card == this.defaultSource) {
        return true;
      }
      return false;
    },
    deletePaymentSource(method) {
      this.isProcessing=true
      this.deleteCardDialog = false;
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { source: method }
      );

      this.removeSourceAction(rec).then(response => {
        if (response.success == true) {
          this.setSnackbar({ text: "Card has been removed Successfully" });
        } else {
          this.setSnackbar({ color: "error", text: response.message });
        }
        this.getPaymentMethods();
        this.isProcessing=false
      });
    },
    setDefaultPaymentMethod(method) {
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { source: method }
      );

      this.setDefaultSourceAction(rec).then(response => {
        if (response.success == true) {
          this.setSnackbar({ text: "Default card updated sucessfully" });
        } else {
          this.setSnackbar({ color: "error", text: response.message });
        }
        this.getPaymentMethods();
      });
    },
    getCardName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },

    getPaymentMethods() {
      this.loadingData = true;
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey }
      );
      this.getSavedPaymentMethods(rec).then(response => {
        if (response.success == true) {
          this.paymentSources = response.sources;
          this.defaultSource = response.defaultSource;
        } else {
          console.log(response);
          this.paymentSources = [];
        }
        this.loadingData = false;
        this.noCardText = "You do not have any saved Credit/Debit card.";
        this.paymentCardDialog = false;
      });
    }
  },
  async activated() {
    await this.getPaymentMethods();
  }
};
</script>